/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Title, Text } from 'components/Text';

import { StyledDialog, Content } from './styles';

// Modal de Termos de uso
const EulaModal = ({
  data, open, onClose, isPrivacy,
}) => {
  let text = data.text
    ? data.text.split(/-{3,}/) : ['', ''];
  text = isPrivacy ? text[1] : text[0];

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
    >
      <Content>
        <IconButton
          color="secondary"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Title>{data.name}</Title>
        <Text dangerouslySetInnerHTML={{ __html: text }} />
      </Content>
    </StyledDialog>
  );
};

EulaModal.propTypes = {
  data: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isPrivacy: PropTypes.bool.isRequired,
};

export default EulaModal;
